<template>
    <div>
        <rkm-modal
            extraLarge
            ref="RkmModal"
            title="Outros profissionais"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="7">
                        <rkm-form-input-autocomplete
                            :repository="repositories.usuario"
                            :requestQueryStringParams="autocompleteRequestParams.usuario"
                            :searchFields="field.autocomplete.usuario"
                            :validations="validations.usuario"
                            text-field="cidadaoNome"
                            label="Profissional"
                            placeholder="Digite o nome ou número do conselho profissional"
                            v-model="model.profissionais.usuario"
                            uppercase
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            label="CBO"
                            :options="ocupacoes"
                            :validations="validations.ocupacao"
                            textField="codigoNome"
                            valueField="id"
                            v-model="model.profissionais.ocupacaoId"
                            show-default-option
                        />
                    </rkm-col>

                    <rkm-col class="text-right">
                        <rkm-button
                            @click="save"
                            color="primary"
                            class="mt-4"
                        >
                            Incluir
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
                
                <rkm-row class="mt-2">
                    <rkm-col cols="12">

                        <rkm-table
                            :fields="fields"
                            :items="items"
                            sort-by="nome"
                            hide-filters
                        >
                            <template v-slot:cell(codigo)="row">
                                {{ row.value | formatProcedimento  }}
                            </template>

                            <template v-slot:cell(actions)="row">

                                <rkm-button
                                    @click="destroy(row.item.profissionalId)"
                                    color="danger"
                                    small
                                    title="Excluir"
                                >
                                    <rkm-icon icon="trash" />
                                </rkm-button>
                            </template>
                        </rkm-table>
                    </rkm-col>
                </rkm-row>
            </rkm-form>

            <template v-slot:footer>
                <rkm-button @click="handleCancel">
                    Fechar
                </rkm-button>
            </template>
        </rkm-modal>
    </div>
</template>

<script>
// Moment.
import moment from 'moment'

//Enums
import permissao from '@/enums/atencao-basica/parametrizacao/permissao'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, stringCase, object, formats } from '@/mixins'

export default {
    computed: {
        validations() {
            return {
                usuario: { required: true },
                ocupacao: { required: true },
            }
        },
        field() {
            return {
                autocomplete: {
                    usuario: [
                        { key: "cadastroCidadao.nome", searchable: true },
                        { key: "cadastroUsuario.registroNumero", searchable: true },
                    ],
                    cid: [{ key: "nome", searchable: true }],
                },
            }
        },
        autocompleteRequestParams() {
            return {
                usuario: {
                    with_not_regularized: true,
                    with_atencao_basica_equipe: true,
                    with_atencao_basica_permissao: this.enums.permissao.ATIVIDADE_COLETIVA
                },
            }
        },
        fields() {
            return [
                {
                    key: "nome",
                    label: "Nome do funcionário",
                },
                {
                    key: "ocupacaoNome",
                    label: "CBO",
                },
                {
                    key: "actions",
                    label: "Ações",
                    class: "col-min",
                },
            ]
        },
        items() {

            return this.model.profissionais ?? []

        },
    },
    created() {

        this.repositories = {
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            atividadeColetiva: this.getConectaSusRepository('atencaoBasica.atividadeColetiva'),
        }

    },
    data: () => ({
        enums: {
            permissao,
        },
        unidades: [],
        equipes: [],
        ocupacoes: [],
        index: null,
        model: {
            profissionais: {
                usuario: null,
                ocupacaoId: null
            }
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(profissional, item) {

            this.item = item
            this.profissional = profissional
            this.model.profissionais = item 

            this.$refs.RkmModal.show()
        },
        save() {

            const ocupacao = this.ocupacoes.find(item => item.id == this.model.profissionais.ocupacaoId)
            const profissionais = this.data.model.profissionais.find(profissional => profissional.profissionalId == this.model.profissionais.usuario.id)
            const profissional = this.model.profissionais.usuario.id == this.profissional.usuario.id

            if (profissional || profissionais) {

                this.showAlert('O profissional já foi cadastrado para esta atividade.', "Atenção")
                return false
                
            }

            const param = {
                ocupacaoId: this.model.profissionais.ocupacaoId,
                ocupacaoNome: ocupacao.codigoNome,
                nome: this.model.profissionais.usuario.cidadaoNome,
                profissionalId: this.model.profissionais.usuario.id,
            }

            if (this.index !== null) {
                this.$set(this.model.profissionais, this.index, this.clone(param))
            } else {

                this.model.profissionais.push(this.clone(param))
            }

            this.$emit('profissionais', this.model.profissionais)

            this.resetForm()
        },
        resetForm() {

            this.model.profissionais.usuario = null
            this.model.profissionais.ocupacaoId = null
        },
        handleCancel() {
            this.profissionais = this.clone(this.data.model.profissionais)

            this.resetForm()
            this.$refs.RkmModal.hide()
        },
        destroy(profissionalId) {

            const index = this.model.profissionais.findIndex(
                (profissional) => profissional.profissionalId === profissionalId
            );

            const destroy = async () => this.model.profissionais.splice(index, 1)

            this.showDeleteConfirmation('Deseja realmente excluir o profissional?', destroy)
        },
        getOcupacoes() {

            this.setLoading()

            this.repositories.atividadeColetiva.getOcupacoes({
                usuario_id: this.model.profissionais.usuario.id,
            })
                .then(({ data }) => {

                    this.ocupacoes = data

                    if (data.length === 1)   {

                        this.model.profissionais.ocupacaoId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setCadastro(field) {

            if (field === 'usuario') {

                this.data.model.cadastro.ocupacaoId = null
                this.data.model.cadastro.dataUsuarioResponsavel = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
            } else {

                this.data.model.cadastro.ocupacaoId = null
                this.data.model.cadastro.dataUsuarioResponsavel = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
            }
        }
    },
    watch: {
        'model.profissionais.usuario': function (usuario) {

            if (usuario && usuario.id) {

                this.getOcupacoes()
            }

            this.setCadastro('usuario')
        },
    },
    mixins: [ repository, stringCase, object, formats ],
    filters: {
        formatProcedimento: formats.formatProcedimento,
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>

<style scoped>
.warning {
    color: var(--warning);
}
</style>